import http from '@services/http';
import * as xform from '@transformers';
import { News } from './interfaces';

export const getRecentArticles = () => {
  return http.get('/news/recent')
    .then((data: News.GetRecentArticles.Response) => ({
      items: xform.normalizeNewsItems(data.items),
    }));
};